import {mandates, mandateFields, mandateDetails} from './MandateFixtures';

export default class FakeMandateService {
  getMandates() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(mandates);
      }, 0);
    });
  }

  getMandateFields() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(mandateFields);
      }, 0);
    });
  }

  getMandateDetails() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(mandateDetails);
      }, 0);
    });
  }
}
